// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./blocks/eventscalendar/style.scss
// module id = 45
// module chunks = 2